import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    '&.MuiButton-root':{
      textTransform: 'none',
      fontWeight: FontWeight.Bold,
      fontSize: 15,
      color: Colors.Gray,      
    }
  },
  avatarInitials: {
    '&.MuiAvatar-root':{
      backgroundColor: Colors.Green,
      fontSize: 13,
      fontWeight: FontWeight.Regular,
      width: 44,
      height: 44,
      marginRight: 16,
    }
  },
  icon: {
    height: 'auto',
    width: 10,
    marginLeft: 13,
  },
}));

export default useStyles;
